import { getNumberFromString } from '@bos/utils';
import { useEffect, useState } from 'react';
const REMOVE_WHITESPACES_REGEX = /\s/g;
export const usePhoneNumberInput = ({ phonePrefix = '', phoneNumberWithoutPrefix = '', maxPhoneCharacterCount, onValueChange, }) => {
    const [prefix, setPrefix] = useState(phonePrefix);
    useEffect(() => {
        if (phonePrefix) {
            setPrefix(phonePrefix);
        }
    }, [phonePrefix]);
    const handleChange = (event) => {
        const value = event.target.value;
        const isMaxPhoneCharacterCount = maxPhoneCharacterCount != null && value.length > maxPhoneCharacterCount;
        const valueWithoutSpaces = value.replace(REMOVE_WHITESPACES_REGEX, '');
        const transformedValueToNumber = getNumberFromString(valueWithoutSpaces);
        const isNumberValue = isFinite(transformedValueToNumber);
        if (isMaxPhoneCharacterCount || !isNumberValue) {
            return undefined;
        }
        onValueChange(valueWithoutSpaces, prefix);
    };
    const handleChangePrefix = (value) => {
        setPrefix(value);
        if (phoneNumberWithoutPrefix) {
            onValueChange(phoneNumberWithoutPrefix, value);
        }
    };
    return { prefix, handleChange, handleChangePrefix };
};
